import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import dayjs from 'dayjs';
import { useEffect, useState } from 'react';
import { isEmpty, sortObject } from 'src/common/helper';
import { Questionaire } from 'src/common/keyText';
import BtnGradient from 'src/components/common/button/BtnGradient';
import SnackbarNotify from 'src/components/common/SnackbarNotify';
import GenerateField from 'src/components/patients/answers/dialog/GenerateField';
import { getAPI, postAPI } from 'src/utils/api';
import { getToken } from 'src/utils/auth';

type QuestionFormType = {
  handleSubmit: () => void;
  patientId: string | null;
};

const QuestionForm: React.FC<QuestionFormType> = (props) => {
  const [notify, setNotify] = useState<any>({
    show: false,
    message: '',
    type: 'error',
  });
  const [questions, setQuestions] = useState<any>(null);
  const [isEdit, setIsEdit] = useState<boolean>(false);
  const [checkAnswer, setCheckAnswer] = useState<any>(null);

  useEffect(() => {
    const token = getToken();

    if (!token) {
      throw new Error('Failed to get access token');
    }
    getAPI(
      `/staff/latest-questionnaire?patient_id=${props.patientId}&token=${token}`
    )
      .then((res) => {
        if (res.code === 200) {
          if (
            (Array.isArray(res.data.answers) &&
              res.data.answers.length === 0) ||
            !res.data.answers
          ) {
            const answers = res.data.metadata.fields.reduce(
              (result: any, field: any) => {
                result[field.field_id] = '';
                return result;
              },
              {}
            );
            setQuestions({ ...res.data, answers: answers });
            setCheckAnswer(answers);
          } else {
            setIsEdit(true);
            setQuestions(res.data);
            setCheckAnswer(res.data.answers);
          }
        }
      })
      .finally(() => {});
  }, [props.patientId]);

  const validate = () => {
    let keyError = '';
    questions.metadata.fields?.map((field: any) => {
      switch (field.type) {
        case 'text':
          if (
            field.required &&
            isEmpty(questions.answers[field.field_id]?.value)
          ) {
            keyError = `${field.label}を入力してください`;
          } else if (
            (field.min_length &&
              questions.answers[field.field_id] &&
              questions.answers[field.field_id]?.value.length <
                field.min_length) ||
            (field.max_length &&
              questions.answers[field.field_id] &&
              questions.answers[field.field_id]?.value.length >
                field.max_length)
          ) {
            keyError = `${field.label} 最小文字数 ${field.min_length}, 最大文字数 ${field.max_length}`;
          }
          break;
        case 'textarea':
          if (
            field.required &&
            isEmpty(questions.answers[field.field_id]?.value)
          ) {
            keyError = `${field.label}を入力してください`;
          } else if (
            (field.min_length &&
              questions.answers[field.field_id] &&
              questions.answers[field.field_id]?.value.length <
                field.min_length) ||
            (field.max_length &&
              questions.answers[field.field_id] &&
              questions.answers[field.field_id]?.value.length >
                field.max_length)
          ) {
            keyError = `${field.label} 最小文字数 ${field.min_length}, 最大文字数 ${field.max_length}`;
          }
          break;
        case 'checkbox':
          console.log(field.required);
          console.log(isEmpty(questions.answers[field.field_id]?.value));
          if (
            field.required &&
            !Array.isArray(questions.answers[field.field_id]?.value)
          ) {
            keyError = `${field.label}を入力してください`;
          } else if (
            field.required &&
            isEmpty(questions.answers[field.field_id]?.value)
          ) {
            keyError = `${field.label}を入力してください`;
          } else if (
            (field.min_selection &&
              questions.answers[field.field_id]?.value.length <
                field.min_selection) ||
            (field.max_selection &&
              questions.answers[field.field_id]?.value.length >
                field.max_selection)
          ) {
            keyError = `${field.label} 最小 ${field.min_selection}, 最大 ${field.max_selection}`;
          }
          break;
        case 'radio':
          if (
            field.required &&
            isEmpty(questions.answers[field.field_id]?.value)
          ) {
            keyError = `${field.label}を入力してください`;
          }
          break;
        case 'date':
          if (
            field.required &&
            isEmpty(questions.answers[field.field_id]?.value)
          ) {
            keyError = `${field.label}を入力してください`;
          } else if (
            dayjs(questions.answers[field.field_id]?.value)
              ?.format('YYYY/MM/DD')
              .toString() === 'Invalid Date'
          ) {
            keyError = `${field.label}を入力してください`;
          } else if (
            field.min_date &&
            dayjs(field.min_date) >
              dayjs(questions.answers[field.field_id]?.value)
          ) {
            keyError = `${field.label} 最小日付 ${field.min_date}`;
          } else if (
            field.max_date &&
            dayjs(field.max_date) <
              dayjs(questions.answers[field.field_id]?.value)
          ) {
            keyError = `${field.label} 最大日付 ${field.max_date}`;
          }
          break;
        case 'time':
          if (
            field.required &&
            isEmpty(questions.answers[field.field_id]?.value)
          ) {
            keyError = `${field.label}を入力してください`;
          } else if (
            dayjs(
              `${dayjs().format('YYYY-MM-DD')} ${
                questions.answers[field.field_id]?.value
              }`
            )
              ?.format('YYYY/MM/DD')
              .toString() === 'Invalid Date'
          ) {
            keyError = `${field.label}を入力してください`;
          } else if (
            field.min_time &&
            dayjs(`${dayjs().format('YYYY-MM-DD')} ${field.min_time}`) >
              dayjs(
                `${dayjs().format('YYYY-MM-DD')} ${
                  questions.answers[field.field_id]?.value
                }`
              )
          ) {
            keyError = `${field.label} 最小時間 ${field.min_time}`;
          } else if (
            field.max_time &&
            dayjs(`${dayjs().format('YYYY-MM-DD')} ${field.max_time}`) <
              dayjs(
                `${dayjs().format('YYYY-MM-DD')} ${
                  questions.answers[field.field_id]?.value
                }`
              )
          ) {
            keyError = `${field.label} 最大時間 ${field.max_time}`;
          }
          break;
        default:
          break;
      }
      return field;
    });
    
    // check validate その他
    if (!keyError) {
      for (const key in questions.answers) {
        const answer = questions.answers[key];
        
        // Check array values
        if (answer?.value && Array.isArray(answer.value)) {
          for (const value of answer.value) {
            if (typeof value === 'string' && value.includes('その他')) {
              // Check if その他 has content in parentheses
              if (value === 'その他' || !value.includes('（') || !value.includes('）')) {
                keyError = `その他を入力してください`;
              }
              
              // Check if there's actual content between parentheses
              const otherInputValue = value.substring(4, value.length - 1);
              if (otherInputValue.trim() === '') {
                keyError = `その他を入力してください`;
              }
            }
          }
        }

        if (answer?.children_answers && typeof answer.children_answers === 'object') {
          for (const childKey in answer.children_answers) {
            const childAnswer = answer.children_answers[childKey];
            if (Array.isArray(childAnswer.value)) {
              for (const value of childAnswer.value) {
                if (typeof value === 'string' && value.includes('その他')) {
                  const otherMoreValue = childAnswer.value.find(
                    (item: string) => item.startsWith('other_more_information: ')
                  );
                  if (otherMoreValue) {
                    // Extract the content after 'other_more_information: '
                    const otherMoreInputValue = otherMoreValue.substring('other_more_information: '.length)
                    if (otherMoreInputValue.trim() === '') {
                      keyError = `その他を入力してください`;
                    }
                  } else {
                    // Check if その他 has content in parentheses
                    if (value === 'その他' || !value.includes('（') || !value.includes('）')) {
                      keyError = `その他を入力してください`;
                    }
                    // Check if there's actual content between parentheses
                    const otherInputValue = value.substring(4, value.length - 1);
                    if (otherInputValue.trim() === '') {
                      keyError = `その他を入力してください`;
                    }
                  }
                }
              }
            }
            if (Array.isArray(childAnswer.dependent_answers)) {
              for (const value of childAnswer.dependent_answers) {
                if (typeof value === 'string' && value.includes('その他')) {
                  // Check if その他 has content in parentheses
                  if (value === 'その他' || !value.includes('（') || !value.includes('）')) {
                    keyError = `その他を入力してください`;
                  }
                  // Check if there's actual content between parentheses
                  const otherInputValue = value.substring(4, value.length - 1);
                  if (otherInputValue.trim() === '') {
                    keyError = `その他を入力してください`;
                  }
                }
              }
            }
          }
        }
      };
    }
    if (keyError) {
      setNotify({
        show: true,
        message: `${keyError}`,
        type: 'error',
      });
      return false;
    }

    setNotify({
      show: false,
      message: '',
      type: 'error',
    });

    return true;
  };

  const handleSubmit = () => {
    try {
      if (!validate()) {
        return;
      }

      const token = getToken();

      if (!token) {
        throw new Error('Failed to get access token');
      }

      postAPI(`/answer-form/create-on-behalf?token=${token}`, {
        answers: questions.answers,
        form_id: questions.form_id,
        form_version: questions.form_version,
        old_submission_id: questions.submission_id,
        patient_id: props.patientId,
      })
        .then((res: any) => {
          if (res.code === 200) {
            setNotify({
              show: true,
              message: Questionaire.SaveSuccess,
              type: 'success',
            });
            props.handleSubmit();
          } else {
            setNotify({
              show: true,
              message: res.msg || 'Failed to post data',
              type: 'error',
            });
          }
        })
        .finally(() => {});
    } catch (error) {
      console.error('Failed to fetch data:', error);
      throw error;
    }
  };

  const handleChangeValue = (name: string, value: any) => {
    const temp = { ...questions.answers };
    temp[name] = value;
    setQuestions((prev: any) => ({
      ...prev,
      answers: { ...temp },
    }));
  };

  return (
    <>
      {notify.show && (
        <SnackbarNotify
          content={notify.message}
          show={true}
          type={notify.type}
          timeDuration={10000}
          handleCloseAlert={() =>
            setNotify({
              show: false,
              message: '',
              type: 'error',
            })
          }
        />
      )}
      {isEdit && (
        <>
          <Typography fontSize={'12px'}>
            以下に、以前ご入力いただいたご回答内容を表示しております。
            <br />
            内容に変更がある場合は、ご自身で修正をお願いいたします。
          </Typography>
          <Typography my={'8px'} fontSize={'12px'}>
            なお、一部の項目については患者様ご自身で修正いただくことができません。その場合は、お手数ですがクリニックスタッフまでご連絡くださいませ。
          </Typography>
        </>
      )}
      {Array.isArray(questions?.metadata?.fields) &&
        sortObject(questions?.metadata.fields).map(
          (field: any, index: number) => {
            return (
              <GenerateField
                field={field}
                key={index}
                answer={
                  questions?.answers ? questions?.answers[field.field_id] : null
                }
                checkAnswer={
                  checkAnswer ? checkAnswer[field.field_id] : null
                }
                handleChangeValue={handleChangeValue}
                isEdit={isEdit}
                staffEdit={false}
              />
            );
          }
        )}
      <Stack alignItems={'center'} my={'16px'}>
        <BtnGradient text='保存' handleButtonClick={handleSubmit} />
      </Stack>
    </>
  );
};

export default QuestionForm;
